//
import Fab from './Fab';
import Card from './Card';
import Tabs from './Tabs';
import Input from './Input';
import Table from './Table';
import Avatar from './Avatar';
import Button from './Button';
import Dialog from './Dialog';
import Accordion from './Accordion';
// ----------------------------------------------------------------------
export default function ComponentsOverrides(theme) {
    return Object.assign(Fab(theme), Card(theme), Tabs(theme), Input(theme), Table(theme), Avatar(theme), Button(theme), Dialog(theme), Accordion(theme));
}
